export default function ToursSection() {
  return (
    <section className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="border border-gray-200 rounded-xl overflow-hidden">
          <div className="grid grid-cols-1 md:grid-cols-2">
            {/* Image */}
            <div className="w-full h-56 md:h-80">
              <img
                src="https://public.readdy.ai/ai/img_res/cf359422eda27f5a4cdf9f247e812cbf.jpg"
                alt="International Tours from Pakistan"
                className="w-full h-full object-cover object-top"
              />
            </div>

            {/* Text */}
            <div className="p-6 md:p-10 flex flex-col justify-center">
              <h2 className="text-xl font-bold text-gray-900 leading-snug">
                Fly Out of Pakistan or Start Your Journey from Anywhere in the World
              </h2>
              <p className="text-gray-600 text-sm mt-4 leading-relaxed">
                When you plan your international holiday with flightfare.pk, you get more than just
                a ticket — you get a fully managed experience. Our travel specialists build custom
                itineraries that cover everything from your outbound flight to hotel check-ins,
                transfers, and guided excursions, all in one place.
              </p>
              <div className="mt-6">
                <a
                  href="/tours"
                  className="inline-block bg-green-600 hover:bg-green-700 text-white text-sm font-semibold px-6 py-2.5 rounded cursor-pointer transition-colors whitespace-nowrap"
                >
                  Browse Packages
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
